<template>
  <v-card
    v-if="getQtyDiscountLinesFromItem(item, buySell).length > 0"
    tile
    flat
  >
    <v-card-title class="pl-0">Volume Discounts</v-card-title>
    <v-card-text class="pl-0">
      <v-simple-table :style="{ width: tableWidth }">
        <thead>
          <th class="text-center pl-4" :width="firstColumnWidth">Quantity</th>
          <th class="text-right pr-4" v-if="showBid()">
            Bid
          </th>
          <th class="text-right pr-4" v-if="showBid()">
            Premium
          </th>
          <th class="text-right pr-4" v-if="showAsk()">
            Ask
          </th>
          <th class="text-right pr-4" v-if="showAsk()">
            Premium
          </th>
        </thead>
        <tbody>
          <tr
            v-for="line in getQtyDiscountLinesFromItemPriced(
              item,
              buySell,
              getSelectedCompany,
              getSpotPrices()
            )"
            :key="line.id"
          >
            <td>
              <span v-if="line.qtyDiscHighRange"
                >{{ Math.round(line.qtyDiscLowRange) || '-' }} -
                {{ Math.round(line.qtyDiscHighRange) || '-' }}
              </span>
              <span v-else>{{ Math.round(line.qtyDiscLowRange) || '-' }}+</span>
            </td>
            <td class="text-right" v-if="showBid()">
              <div v-if="line.bid">
                {{ line.bid | toCurrency }}
              </div>
              <div v-else>-</div>
            </td>
            <td class="text-right" v-if="showBid()">
              <div v-if="line.bid">
                <div class="text-caption">{{ line.bidPremiumText }}</div>
              </div>
              <div v-else>-</div>
            </td>
            <td class="text-right" v-if="showAsk()">
              <div v-if="line.ask">
                {{ line.ask | toCurrency }}
              </div>
              <div v-else>-</div>
            </td>
            <td class="text-right" v-if="showAsk()">
              <div v-if="line.ask">
                <div class="text-caption">{{ line.askPremiumText }}</div>
              </div>
              <div v-else>-</div>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import productMixin from '@/mixins/product'
import { mapGetters, mapState } from 'vuex'

export default {
  props: ['item', 'buySell', 'tradeTicket', 'forceTableWidth'],
  mixins: [productMixin],
  methods: {
    getSpotPrices() {
      if (this.tradeTicket) return this.tradeTicketSpotPrices
      return this.spotPrices
    },
    showAsk() {
      return this.item.activelySelling && (!this.buySell || this.buySell === `buy`)
    },
    showBid() {
      return this.item.activelyBuying && (!this.buySell || this.buySell === `sell`)
    }
  },
  computed: {
    firstColumnWidth() {
      // only column
      if (!this.showAsk() && !this.showBid()) return '100%';
      // one of three columns
      else if (!this.showAsk() || !this.showBid()) return '33%';
      // one of five columns
      return '20%';
    },
    tableWidth() {
      if (this.forceTableWidth) return this.forceTableWidth;
      // one column
      if (!this.showAsk() && !this.showBid()) return '20%';
      // three columns
      else if (!this.showAsk() || !this.showBid()) return '60%';
      // five columns
      return '100%';
    },
    ...mapState({
      spotPrices: (state) => state.user.spotPrices,
      tradeTicketSpotPrices: (state) => state.user.tradeTicketSpotPrices,
    }),
    ...mapGetters(['getSelectedCompany']),
  },
}
</script>
